/**
 * @generated SignedSource<<5393e845c970c0ded0df9d8f11061975>>
 * @relayHash 454f668339db2233f1f11c49f953b3c9
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/560.0.0-2026-05-19T17:25:42.599Z/useDeleteDraftMutation

import { ConcreteRequest } from 'relay-runtime';
export type NftDeleteItemDraftInput = {
  clientMutationId?: string | null;
  nftItemId: string;
};
export type useDeleteDraftMutation$variables = {
  input: NftDeleteItemDraftInput;
};
export type useDeleteDraftMutation$data = {
  readonly nftDeleteItemDraft: {
    readonly __typename: "NftDeleteItemDraftPayload";
  } | null;
};
export type useDeleteDraftMutation = {
  response: useDeleteDraftMutation$data;
  variables: useDeleteDraftMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "NftDeleteItemDraftPayload",
    "kind": "LinkedField",
    "name": "nftDeleteItemDraft",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeleteDraftMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDeleteDraftMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-nft/560.0.0-2026-05-19T17:25:42.599Z/useDeleteDraftMutation",
    "metadata": {},
    "name": "useDeleteDraftMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "41624f9cb20802b6db78b207922b896e";

export default node;
